/**
 * @file 申請・承認表示
 *
 */
'use strict'
import Common from '../../Utils/Common'

/**
 * @classname ShowInfo
 * @classdesc 申請・承認情報表示
 */
export default class ShowInfo {
	/**
	 * @constructor
	 * @param {jQuery} $e - $('#show-info')
	 */
	constructor($e) {
		console.log('ShowInfo.constructor')
		this._$e = $e;
		this.hideColumn();
		$e.on('change', () => this.onChange());
	}


	/**
	 * changeコールバック
	 *
	 * @memberof ShowInfo
	 */
	hideColumn() {
		console.log('ShowInfo.hideColumn');
		$('.apply_column').hide();
		$('.transfer_column').hide();
		$('.additional_column').hide();
		$('.chase_column').hide();
		$('.expulsion_column').hide();
	}


		/**
	 * changeコールバック
	 *
	 * @memberof ShowInfo
	 */
	onChange() {
		console.log('ShowInfo.onChange');
		this.hideColumn();
		const val = this._$e.val();
		$(val).show();
	}
}
